'use client';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';

interface TooltipToggleModeProps {
  mode: 'Play' | 'Practice';
  children: ReactNode;
}

export function TooltipToggleMode({ mode, children }: TooltipToggleModeProps) {
  const { t } = useTranslation();
  const tooltipKey =
    mode === 'Play' ? 'tooltip.play_mode' : 'tooltip.practice_mode';

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          className='w-64 ml-2'
          sideOffset={14}
          side='top'
          variant='zinc'
        >
          <div className='w-full m-2'>
            <div className='space-y-1'>
              <p className='text-sm'>{t(tooltipKey)}</p>
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
